/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseApiClient } from '../base-api-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreatePlanOutlineCommandParam } from '../models/create-plan-outline-command-param';
import { PlanOutlineModel } from '../models/plan-outline-model';

@Injectable({ providedIn: 'root' })
export class PlanOutlinesApiClient extends BaseApiClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createPlanOutlines()` */
  static readonly CreatePlanOutlinesPath = '/api/v1/plan-outlines';

  /**
   * Add a new planOutline.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlanOutlines$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanOutlines$Plain$Response(
    params: {
      body: Array<CreatePlanOutlineCommandParam>
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<PlanOutlineModel>>> {
    const rb = new RequestBuilder(this.rootUrl, PlanOutlinesApiClient.CreatePlanOutlinesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PlanOutlineModel>>;
      })
    );
  }

  /**
   * Add a new planOutline.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlanOutlines$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanOutlines$Plain(
    params: {
      body: Array<CreatePlanOutlineCommandParam>
    },
    context?: HttpContext
  ): Observable<Array<PlanOutlineModel>> {
    return this.createPlanOutlines$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlanOutlineModel>>): Array<PlanOutlineModel> => r.body)
    );
  }

  /**
   * Add a new planOutline.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPlanOutlines()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanOutlines$Response(
    params: {
      body: Array<CreatePlanOutlineCommandParam>
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<PlanOutlineModel>>> {
    const rb = new RequestBuilder(this.rootUrl, PlanOutlinesApiClient.CreatePlanOutlinesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PlanOutlineModel>>;
      })
    );
  }

  /**
   * Add a new planOutline.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPlanOutlines$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPlanOutlines(
    params: {
      body: Array<CreatePlanOutlineCommandParam>
    },
    context?: HttpContext
  ): Observable<Array<PlanOutlineModel>> {
    return this.createPlanOutlines$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlanOutlineModel>>): Array<PlanOutlineModel> => r.body)
    );
  }

  /** Path part for operation `getPlanOutlinesByPlan()` */
  static readonly GetPlanOutlinesByPlanPath = '/api/v1/plans/{planId}/plan-outlines';

  /**
   * Get planOutlines per PlanId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlanOutlinesByPlan$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlanOutlinesByPlan$Plain$Response(
    params: {
      planId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<PlanOutlineModel>>> {
    const rb = new RequestBuilder(this.rootUrl, PlanOutlinesApiClient.GetPlanOutlinesByPlanPath, 'get');
    if (params) {
      rb.path('planId', params.planId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PlanOutlineModel>>;
      })
    );
  }

  /**
   * Get planOutlines per PlanId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlanOutlinesByPlan$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlanOutlinesByPlan$Plain(
    params: {
      planId: number;
    },
    context?: HttpContext
  ): Observable<Array<PlanOutlineModel>> {
    return this.getPlanOutlinesByPlan$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlanOutlineModel>>): Array<PlanOutlineModel> => r.body)
    );
  }

  /**
   * Get planOutlines per PlanId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPlanOutlinesByPlan()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlanOutlinesByPlan$Response(
    params: {
      planId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<PlanOutlineModel>>> {
    const rb = new RequestBuilder(this.rootUrl, PlanOutlinesApiClient.GetPlanOutlinesByPlanPath, 'get');
    if (params) {
      rb.path('planId', params.planId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PlanOutlineModel>>;
      })
    );
  }

  /**
   * Get planOutlines per PlanId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPlanOutlinesByPlan$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPlanOutlinesByPlan(
    params: {
      planId: number;
    },
    context?: HttpContext
  ): Observable<Array<PlanOutlineModel>> {
    return this.getPlanOutlinesByPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlanOutlineModel>>): Array<PlanOutlineModel> => r.body)
    );
  }

  /** Path part for operation `deletePlanOutlinesByPlan()` */
  static readonly DeletePlanOutlinesByPlanPath = '/api/v1/plans/{planId}/plan-outlines';

  /**
   * Delete planOutlines per PlanId.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePlanOutlinesByPlan()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePlanOutlinesByPlan$Response(
    params: {
      planId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, PlanOutlinesApiClient.DeletePlanOutlinesByPlanPath, 'delete');
    if (params) {
      rb.path('planId', params.planId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete planOutlines per PlanId.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePlanOutlinesByPlan$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePlanOutlinesByPlan(
    params: {
      planId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.deletePlanOutlinesByPlan$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
